import ChangeLanguageDialog from "./ChangeLanguageDialog";

export default ChangeLanguageDialog;
